// extracted by mini-css-extract-plugin
export default {"login":"Login_login__TxnoS","box_login":"Login_box_login__+Q-78","userid":"Login_userid__TV53D","text_error":"Login_text_error__J7Hpd","btn_login":"Login_btn_login__LLotQ"};